import React, { useRef, useEffect, useState } from 'react';

import { PanoRoot, ChildrenCloak } from '../styles/viewer';
import ModalsWrapper from './modals-wrapper';
import SlideOutMenu from './slide-out-menu/menu';
import { createScene, getChildList } from '../utils/viewer-utils';
import { Themes } from '../utils/types';
import DragMessagePopup from './drag-message-popup';

export default function Viewer({ children, className, style, theme=Themes.Room2, hideMenu=false, menuDefaultOpen=false }) {

  const hotspots = getChildList(children);

  // Hooks
  const rootRef = useRef(null);
  const [ isSceneLoaded, setSceneLoaded ] = useState(false);

  // useEffects
  useEffect(() => {
    if(rootRef.current && !isSceneLoaded) {
      const scene = createScene(rootRef.current, theme);
      scene.switchTo();

      hotspots.forEach((hotspot, index) => {
        const yaw = hotspot.props.yaw ?? 0;
        const pitch = hotspot.props.pitch ?? 0;
        const position = { yaw, pitch };
        scene.hotspotContainer().createHotspot(hotspot.ref.current, position);
      });

      setSceneLoaded(true);
    }
    
  }, [ rootRef, hotspots, isSceneLoaded, theme ]);

  return(
    <ModalsWrapper>
      { ! hideMenu && <SlideOutMenu hotspots={hotspots} defaultOpen={menuDefaultOpen} /> }
      <PanoRoot ref={rootRef} className={className} style={style} >
        <ChildrenCloak>
          { hotspots }
        </ChildrenCloak>
      </PanoRoot>
      <DragMessagePopup />
    </ModalsWrapper>
  );
}